import DatatableComponent from "../../../../../../../../components/common/DatatableComponent/DatatableComponent"
import CampaignBanner from "../../../../../../../../assets/images/campaign-banner.png"

const Closed = () => {
  const data = [
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
  ]

  const columns = [
    {
      name: "Campaign name",
      selector: (row) => row.campaignName,
    },
    {
      name: "Campaign Banner",
      cell: (row) => <img src={row.campaignBanner} className="img-fluid" />,
    },
    {
      name: "Campaign Start Date",
      selector: (row) => row.campaignStartDate,
    },
    {
      name: "Campaign End Date",
      selector: (row) => row.campaignEndDate,
    },
    {
      name: "Registration Closing Date",
      selector: (row) => row.regestrationClosingDate,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Action",
      cell: () => <div className="cursor-pointer">View Invite</div>,
    },
  ]

  return (
    <div className="bg-white p-2">
      <DatatableComponent data={data} columns={columns} type={"gray-bordered"} />
    </div>
  )
}

export default Closed
